import { FC } from "react";

interface AcceptCheckMarkSVGProps {
    className?: string;
}

const AcceptCheckMarkSVG: FC<AcceptCheckMarkSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14 1L7 15L1 8.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default AcceptCheckMarkSVG;
